export default class VOCFiltersViewModel {
    public isActive: boolean = false;
    public channel: string = '';
    public question: string = '';
    public answer: string = '';
}